import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import Notification, { NotificationProps } from "shared/components/notification/Notification";
import { useStyles } from "../styles/ConfigurarBuscaNFEmailStyles";
import { EnumTipoConfiguracaoEmail } from 'constants/EnumTipoConfiguracaoEmail';

interface OpcaoConfiguracaoProps {
  id: string;
  label: string;
  value: EnumTipoConfiguracaoEmail;
  checked: boolean;
  onChange: () => void;
  notification: NotificationProps;
  children?: ReactNode;
}

const OpcaoConfiguracao: React.FC<OpcaoConfiguracaoProps> = ({
  id,
  label,
  value,
  checked,
  onChange,
  notification,
  children,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.notificationArea}>
      <div className={classes.radioOption}>
        <input
          type="radio"
          id={id}
          name="buscaEmail"
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={id} className={classes.radioLabel}>
          {label}
        </label>
      </div>
      {checked && (
        <>
          <Box style={{ flex: '0 1 auto', minWidth: 0 }}>
            <Notification {...notification} />
          </Box>
          {children}
        </>
      )}
    </Box>
  );
};

export default OpcaoConfiguracao;